import styled from "@emotion/styled";
import { identity } from "lodash";
import * as React from "react";
import { Field } from "react-final-form";

import { TextAreaField } from "@livechat/design-system";

import { IAgent } from "store/entities/agents";

import { AgentFormSection } from "../AgentFormSection";
import { AgentFormSectionId } from "../constants";
import { LockIcon } from "../styled";

interface IProps {
  canChange: boolean;
}

const FullWidthTextAreaField = styled(TextAreaField)`
  .lc-textarea {
    resize: vertical;
    min-height: 2.5em;
    width: 100%;
  }
`;

const AgentSignature: React.FC<IProps> = ({ canChange }) => (
  <AgentFormSection
    header={{
      id: AgentFormSectionId.Signature,
      component: (
        <>
          Signature
          {!canChange && <LockIcon />}
        </>
      ),
    }}
  >
    <Field
      name="signature"
      parse={
        // this ensures react-final-form never sets value to "undefined"
        // https://github.com/final-form/react-final-form/issues/130#issuecomment-425482365
        identity
      }
      className="fs-mask"
      disabled={!canChange}
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render={(props: any) => (
        <FullWidthTextAreaField
          id="rich-text-area"
          labelText="Signature is added at the end of messages sent by this agent."
          // @ts-expect-error TS(2322)
          value={(props.input.value as IAgent["signature"]).text}
          rows={4}
          maxLength={1000}
          // FIXME: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onChange={(event: any) => {
            props.input.onChange({ target: { value: { text: event.target.value, richTextObj: null } } });
          }}
        />
      )}
    />
  </AgentFormSection>
);

export default AgentSignature;
